// Monitoring texts (merged under the "monitoring" key: t('monitoring.alerts.title')).
// "@" starts a linked message in vue-i18n: a literal one is written {'@'}.
export default {
  nav: 'Monitoramento',
  common: {
    disabledTitle: 'Monitoramento não disponível',
    disabledText: 'O Monitoramento não está ligado para esta empresa. Fale com o suporte para ativar.',
    forbiddenTitle: 'Sem permissão',
    forbiddenText: 'O seu papel não permite configurar o Monitoramento.',
    loadError: 'Não foi possível carregar o Monitoramento.',
    noMatch: 'Nenhum alerta nesta situação.',
    yes: 'Sim',
  },
  permissions: {
    group: 'Monitoramento',
    groupHint: 'Alertas automáticos com consultas aos sistemas da empresa, enviados por e-mail, WhatsApp e no portal.',
    monitoramento_configurar: 'Monitoramento (técnico)',
    monitoramento_configurar_hint:
      'Cria, edita, testa e pausa alertas. Dá leitura de todos os dados que a conexão do Monitoramento enxerga, porque as consultas são escritas livremente.',
    monitoramento_historico: 'Ver histórico do Monitoramento',
    monitoramento_historico_hint: 'Vê todos os alertas e os resultados, sem editar.',
    ownerLocked: 'O dono tem todas as permissões do Monitoramento.',
    changes: 'Monitoramento: {items}',
    changesNone: 'sem permissões',
  },
  status: { active: 'Ativo', paused: 'Pausado', disabled: 'Desligado' },
  sendPolicy: { always: 'Sempre envia', only_on_divergence: 'Só quando houver itens' },
  channel: { email: 'E-mail', whats_app: 'WhatsApp', bell: 'Portal' },
  connection: {
    missing: 'A conexão do Monitoramento ainda não foi configurada: os testes e as execuções não vão funcionar.',
    not_tested: 'A conexão do Monitoramento ainda não foi testada.',
    access_issues: 'A conexão do Monitoramento precisa ser corrigida (o usuário do banco não é somente leitura).',
    unavailable: 'A conexão do Monitoramento não está respondendo.',
    connected: 'Conexão pronta.',
  },
  timeZones: {
    America_Sao_Paulo: 'Brasília (padrão)',
    America_Manaus: 'Manaus',
    America_Cuiaba: 'Cuiabá',
    America_Rio_Branco: 'Rio Branco',
    America_Noronha: 'Fernando de Noronha',
  },
  alerts: {
    title: 'Monitoramento',
    subtitle: 'Alertas automáticos com a situação dos processos da empresa.',
    myTitle: 'Meus alertas',
    mySubtitle: 'Os alertas automáticos que você recebe.',
    new: 'Novo alerta',
    filterAll: 'Todos',
    emptyTitle: 'Nenhum alerta ainda',
    emptyText: 'Crie um alerta para receber, nos horários que escolher, o que precisa de atenção.',
    myEmptyTitle: 'Você ainda não recebe alertas',
    myEmptyText: 'Quando alguém incluir você num alerta, ele aparece aqui.',
    columns: {
      name: 'Alerta',
      status: 'Situação',
      schedule: 'Quando',
      nextRun: 'Próxima execução',
      sendPolicy: 'Envio',
      blocks: 'Consultas',
      recipients: 'Destinatários',
      iReceive: 'Recebo',
    },
  },
  emailSettings: {
    title: 'E-mails do Monitoramento',
    text: 'Largura do conteúdo dos e-mails de alerta: as tabelas ocupam toda essa largura. A prévia do "Testar" no editor de alertas usa a mesma.',
    width: 'Largura do conteúdo (px)',
    widthHint: 'Entre {min} e {max} px; vazio usa o padrão ({default} px).',
    phones: 'No celular, cada linha vira um cartão.',
    useDefault: 'Usar o padrão',
    saved: 'Largura dos e-mails do Monitoramento salva',
  },
  alert: {
    title: 'Alerta',
    nextRun: 'próxima: {when}',
    withAiSummary: 'com resumo da IA',
    pause: 'Pausar',
    resume: 'Retomar',
    edit: 'Editar',
    delete: 'Excluir',
    paused: 'Alerta pausado.',
    resumed: 'Alerta retomado.',
    deleted: 'Alerta excluído.',
    notFound: 'Alerta não encontrado.',
    disabledNotice:
      'Este alerta foi desligado depois de {n} execuções seguidas com falha. Corrija a consulta ou a conexão e clique em "Retomar".',
    keyColumns: 'Identifica cada item por: {columns}',
    lastRun: 'Última execução',
    nextRunLabel: 'Próxima execução',
    sending: 'Envio',
    recipientsCount: 'Destinatários',
    noRunYet: 'Ainda não rodou',
    notScheduled: 'Sem próxima',
    withoutAiSummary: 'sem resumo da IA',
    newItems: '{n} novo | {n} novos',
    items: '{n} item | {n} itens',
    allClear: 'Tudo em dia',
    receivesBy: 'Recebe por: {channels}',
    nobody: 'Ninguém recebe este alerta ainda.',
    lastRunRows: 'Na última execução: {rows}',
    showSql: 'Ver SQL',
    hideSql: 'Ocultar SQL',
    copySql: 'Copiar SQL',
    sqlCopied: 'Consulta copiada',
    deleteTitle: 'Excluir "{name}"?',
    deleteText: 'O alerta e todo o histórico de execuções serão apagados. Isso não pode ser desfeito.',
  },
  editor: {
    newTitle: 'Novo alerta',
    editTitle: 'Editar alerta',
    backToAlert: 'Voltar ao alerta',
    general: 'Alerta',
    name: 'Nome',
    namePlaceholder: 'Ex.: Resumo de segunda',
    description: 'Descrição (opcional)',
    sendPolicy: 'Quando enviar',
    sendPolicyHint: {
      only_on_divergence: 'Cada linha que a consulta retornar conta como um item que precisa de atenção. Sem itens, nada é enviado.',
      always: 'Envia em todo horário, também quando está tudo em dia.',
    },
    aiSummary: 'Resumo da IA',
    aiSummaryHint: 'Até 3 frases no início do alerta, com o que mudou. A IA só lê o resultado: não consulta nada nem faz contas.',
    schedule: 'Agenda',
    days: 'Dias da semana',
    times: 'Horários',
    timeLabel: 'Horário {n}',
    addTime: 'Adicionar horário',
    removeTime: 'Remover horário',
    timeZone: 'Fuso horário',
    nextRuns: 'Próximas execuções',
    nextRunsInvalid: 'Ajuste os dias e horários para ver as próximas execuções.',
    queries: 'Consultas',
    queriesHint:
      'Cada consulta vira um bloco do alerta. Escreva um SELECT que retorne só o que precisa de atenção e teste antes de salvar: o teste roda de verdade, somente leitura.',
    variables: 'Datas automáticas disponíveis',
    blockNumber: 'Consulta {n}',
    untitledBlock: 'Consulta sem título',
    blockColumns: '{n} coluna | {n} colunas',
    identifiesBy: 'identifica por {columns}',
    notTested: 'Sem teste',
    blockHasError: 'Corrigir',
    blockTitle: 'Título',
    blockTitlePlaceholder: 'Ex.: Processos atrasados',
    sql: 'SQL',
    sqlPlaceholder: "select processo as \"Processo\", cliente as \"Cliente\"\nfrom processos\nwhere prazo < {'@'}hoje",
    copySql: 'Copiar',
    copySqlLabel: 'Copiar a consulta',
    sqlCopied: 'Consulta copiada',
    sqlHint: "Um SELECT ou WITH. Use {'@'}hoje, {'@'}inicio_semana… para as datas. Os nomes das colunas (AS) são os títulos no alerta.",
    test: 'Testar',
    tested: 'Testada',
    changedSinceTest: 'Alterada depois do teste',
    previewStats: '{rows} linha(s) em {ms} ms',
    previewTruncated: 'mostrando as primeiras',
    previewEmpty: 'A consulta não retornou nenhuma linha agora.',
    previewAsEmail: 'Como no e-mail ({width} px). Arraste a divisória entre duas colunas para dividir o espaço; duplo clique numa coluna ajusta todas ao conteúdo.',
    previewDevice: 'Visualizar como',
    previewDesktop: 'Computador',
    previewPhone: 'Celular',
    previewAsPhone: 'Como no celular ({width} px): cada linha vira um cartão.',
    changeEmailWidth: 'Alterar a largura do e-mail',
    resetWidths: 'Colunas iguais',
    fitWidths: 'Ajustar ao conteúdo',
    fitHint: 'Duplo clique: ajustar as colunas ao conteúdo',
    widthsAuto: 'Larguras: colunas iguais',
    widthsCustom: 'Larguras: {list}',
    resizeColumn: 'Largura da coluna {column}',
    keyColumns: 'Colunas que identificam cada item',
    keyColumnsHint: 'Com elas, o alerta diz o que é novo, o que foi resolvido e o que continua. Sem elas, só compara a quantidade.',
    moveUp: 'Mover para cima',
    moveDown: 'Mover para baixo',
    removeBlock: 'Remover consulta',
    addBlock: 'Adicionar consulta',
    recipients: 'Destinatários',
    recipientsHint: 'Pessoas com acesso à empresa. Cada uma escolhe por onde recebe.',
    addRecipient: 'Adicionar pessoa…',
    addRecipientLabel: 'Adicionar destinatário',
    removeRecipient: 'Remover destinatário',
    unknownPerson: 'Pessoa',
    notMember: 'Sem acesso à empresa',
    noWhatsApp: 'Sem WhatsApp cadastrado: não vai receber por lá',
    noEmail: 'Sem e-mail cadastrado: não vai receber por lá',
    noChannel: 'Escolha pelo menos um canal',
    untested: 'Há 1 consulta sem teste | Há {n} consultas sem teste',
    create: 'Criar alerta',
    created: 'Alerta criado.',
    saved: 'Alerta salvo.',
  },
  runs: {
    title: 'Histórico',
    emptyTitle: 'Nenhuma execução ainda',
    emptyText: 'As execuções aparecem aqui nos horários do alerta ou quando você clica em "Executar agora".',
    runNow: 'Executar agora',
    runNowTitle: 'Executar agora',
    runNowText: 'A consulta roda em alguns segundos. Quem deve receber o resultado?',
    queued: 'Execução na fila. O resultado aparece no histórico em instantes.',
    scheduled: 'Agendada',
    manual: 'Manual · {name}',
    audience: { requester: 'Só para mim', all: 'Para todos os destinatários' },
    result: { withItems: 'Com itens', allClear: 'Tudo em dia' },
    columns: { when: 'Horário', status: 'Resultado', items: 'Itens', new: 'Novos', trigger: 'Origem', delivery: 'Envio' },
  },
  runStatus: {
    pending: 'Na fila',
    running: 'Executando',
    completed: 'Concluída',
    partial_failure: 'Parcial',
    failed: 'Falhou',
    skipped: 'Não executada',
  },
  delivery: { not_needed: 'Nada a enviar', pending: 'Enviando', done: 'Enviado' },
  deliveryKind: { result: 'Resultado', failure_notice: 'Aviso de falha' },
  deliveryStatus: { pending: 'Pendente', sent: 'Enviado', failed: 'Falhou', skipped: 'Não enviado' },
  run: {
    title: 'Resultado',
    inProgress: 'Esta execução ainda está em andamento. A página se atualiza sozinha.',
    aiSummary: 'Resumo (gerado por IA)',
    attempts: '{n} tentativas',
    csv: 'Baixar CSV',
    noRows: 'Nenhum item: tudo em dia.',
    truncated: 'Há mais itens do que o limite de linhas de uma execução.',
    new: 'Novo',
    ongoing: 'Continua',
    situation: 'Situação',
    resolved: '1 item resolvido desde a execução anterior | {n} itens resolvidos desde a execução anterior',
    deliveries: 'Envio',
    person: 'Pessoa',
    round: 'reenvio {n}',
    columns: { person: 'Pessoa', channel: 'Canal', kind: 'Tipo', status: 'Situação', detail: 'Detalhe', sentAt: 'Enviado em' },
    resend: 'Reenviar',
    resendTitle: 'Reenviar o resultado',
    resendText: 'Envia o mesmo resultado de novo, sem rodar a consulta. Para quem?',
    resent: 'Reenvio na fila.',
    notFound: 'Resultado não encontrado',
    notFoundText: 'Ele pode ter sido apagado pela retenção (90 dias) ou não ter sido enviado para você.',
  },
}
